import { render } from "./CustomPageHeader.vue?vue&type=template&id=125ba167"
import script from "./CustomPageHeader.vue?vue&type=script&lang=js"
export * from "./CustomPageHeader.vue?vue&type=script&lang=js"

import "./CustomPageHeader.vue?vue&type=style&index=0&id=125ba167&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__